<div class="quote">
    <clients-grid-layout
        [style]="'max-width: 100%'"
        [classTailwind]="'max-w-full w-full h-full flex flex-col fxs:flex-col fsm:flex-col justify-center items-center content-center gap-0'"
    >
        <div class="symbol"><img [src]="imageLocation" alt="Quote" [style]="'width: 40px'" /></div>
        <div class="text">
            <p>{{ quote }}</p>
        </div>
        <div class="profile-image" *ngIf="authorImage"><img [src]="authorImage" [alt]="authorDescription" /></div>
        <div class="profile-data">
            <h2>{{ author }}</h2>
            <h3>{{ authorDescription }}</h3>
        </div>
    </clients-grid-layout>
</div>
